import React from 'react';

const Carousel = {};

/**
 * 接收items 数据，显示图片
 * 强制设置不超过5幅图片
 *
 */
export default class CarouselInstance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [
        {
          src: '',
          caption: `### 技术介绍\n` + 
            `成熟可靠的企业信息化解决方案`
        },
        {
          src: '',
          caption: `### 解决方案\n` + 
            `软件开发、系统集成、系统运维`
        }
      ]
    }
  }

  render() {
    return (
      <Carousel slide={false}> 
        <Carousel.Item> 
          <img src={process.env.PUBLIC_URL + '/images/img100.jpg'} alt="" className="img-responsive"/> 
          <Carousel.Caption> 
            <h3>技术介绍</h3> 
            <p>成熟可靠的企业管理信息化解决方案，为中小企业提供管理信息化技术服务.</p> 
          </Carousel.Caption> 
        </Carousel.Item> 
        <Carousel.Item> 
          <img src={process.env.PUBLIC_URL + '/images/img101.png'} alt="" className="img-responsive"/> 
          <Carousel.Caption> 
            <h3>解决方案</h3> 
            <p>软件开发、系统集成、系统运维.</p> 
          </Carousel.Caption> 
        </Carousel.Item>
      </Carousel> 
    );
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/bootstrap/Carousel.js